import { Tab, Tabs } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import type { ProductGroups } from "../../../../../modules/merchant/admin/products/productsTypes"

const useStyles = makeStyles()((theme) => ({
    tabs: {
        background: theme.palette.common.white,
        "& .MuiTab-root": {
            color: theme.palette.tailwind.slate[400],
            textTransform: "none",
            padding: "1rem 1.25rem",
        },
        "& .Mui-selected": {
            fontWeight: 600,
            color: `${theme.palette.tailwind.slate[900]} !important`,
        },
        "& .MuiTabs-indicator": {
            backgroundColor: theme.palette.tailwind.slate[900],
            height: ".125rem",
        },
    },
}))

type ShopCategoryBarProps = Readonly<{
    groups: ProductGroups[]
    activeGroupId: number | null
    isFavoriteFilter: boolean
    onGroupChange: (groupId: number) => void
}>

export function ShopCategoryBar({ groups, activeGroupId, isFavoriteFilter, onGroupChange }: ShopCategoryBarProps) {
    const { classes } = useStyles()

    if (groups.length === 0) return null

    return (
        <Tabs
            value={isFavoriteFilter ? false : (activeGroupId ?? false)}
            variant="scrollable"
            scrollButtons="auto"
            className={classes.tabs}
            onChange={(_, value: number) => onGroupChange(value)}
        >
            {groups.map((group) => (
                <Tab key={group.id} label={group.name} value={group.id} />
            ))}
        </Tabs>
    )
}
